/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HealthService } from './services/health.service';
import { SvgzapiCoreService } from './services/svgzapi-core.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HealthService,
    SvgzapiCoreService,
    ApiConfiguration
  ],
})
export class SVGZAPICoreModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<SVGZAPICoreModule> {
    return {
      ngModule: SVGZAPICoreModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: SVGZAPICoreModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('SVGZAPICoreModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
